// src/components/CookieConsentBanner.jsx
import React, { useState, useEffect } from 'react';
import { initializeAnalytics } from '../services/firebase';
import { initializeClarity } from '../services/clarity';
import { initializeMetaPixel } from '../services/metaPixel';

const CookieConsentBanner = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem('cookie_consent');
    if (consent === 'granted') {
      initializeAnalytics();
      initializeClarity();
      initializeMetaPixel();
    } else if (!consent) {
      setIsVisible(true);
    }
  }, []);

  const handleAccept = () => {
    localStorage.setItem('cookie_consent', 'granted');
    setIsVisible(false);
    initializeAnalytics();
    initializeClarity();
    initializeMetaPixel();
  };

  const handleDecline = () => {
    localStorage.setItem('cookie_consent', 'denied');
    setIsVisible(false);
  };

  if (!isVisible) return null;

  return (
    <div className="fixed bottom-0 left-0 right-0 z-50 bg-slate-800/90 backdrop-blur-sm text-white p-2 shadow-lg animate-fade-in">
      <div className="container mx-auto flex flex-col sm:flex-row items-center justify-between gap-2">
        <p className="text-xs sm:text-sm text-slate-300 leading-snug">
          Usamos cookies de análisis (Google Analytics, Microsoft Clarity y Meta Pixel) para mejorar nuestro servicio y comprender cómo se usa la plataforma. Puedes leer más en nuestra{' '}
          <a
            href="/privacidad"
            target="_blank"
            rel="noopener noreferrer"
            className="font-semibold text-white hover:underline"
          >
            Política de Privacidad
          </a>.
        </p>
        <div className="flex-shrink-0 flex gap-2">
          <button
            onClick={handleDecline}
            className="px-3 py-1 text-xs sm:text-sm font-medium rounded-md bg-slate-600 hover:bg-slate-500 transition-colors"
          >
            Rechazar
          </button>
          <button
            onClick={handleAccept}
            className="px-3 py-1 text-xs sm:text-sm font-medium rounded-md bg-blue-600 hover:bg-blue-500 transition-colors"
          >
            Aceptar
          </button>
        </div>
      </div>
    </div>
  );
};

export default CookieConsentBanner;
